export default __webpack_public_path__ + "1eb25d4bf31d7431a31c54729ca6fed6.svg";